<template>
  <div v-if="hasBreadcrumbs" class="d-lg-none mobile-breadcrumbs px-4 py-2">
    <breadcrumbs :hideLogo="true" />
  </div>
</template>

<script>
import Breadcrumbs from "@/examples/Breadcrumbs.vue";

export default {
  name: "MobileBreadcrumbs",
  components: { Breadcrumbs },
  computed: {
    hasBreadcrumbs() {
      return this.$store.state.theme.breadcrumbs?.length > 0;
    },
  },
};
</script>

<style scoped>
.mobile-breadcrumbs {
  font-size: 13px;
}
</style>
